module.exports = __webpack_public_path__ + "img/icon_kg.3e735bb5.png";